import { Box, Container, HStack, Image, Heading, Flex, Spinner } from '@chakra-ui/react'
import { LoginBlock } from '../LoginBlock'
import { Link as RouterLink } from 'react-router-dom'

export const Navbar = () => {

  return (
    <Flex className="no-print" zIndex={100} as="header" position="fixed" direction='column' w="100%" bg="bg.surface" boxShadow='0 0 10px 0'>

      <Container py="4" as="section" >
        <HStack justify="space-between">
          <Heading hideBelow='md' size='xs'>
            <RouterLink to="/">EIT Label for Non-Degree Education and Learning</RouterLink>
          </Heading>
          <Heading hideFrom='md' size='xs'>
            <RouterLink to="/">EIT Label</RouterLink>
          </Heading>
          <HStack hideBelow='lg'>
            <Image h="10" mr='5' src="/logo-eit-urban-mobility.svg" alt="Logo" />
            <Image h="10" src="/co-funded-by-the-eu-light.svg" alt="Co-funded by the EU" />
          </HStack>
          <LoginBlock />
        </HStack>
      </Container>

      <Box bg='bg.accent.default' as='section'>
        <Container py='2' as="section">
          <HStack minH="6" justify='space-between'>
            <Box id='eitum-breadcrumb' />
            <HStack spacing='4'>
              <HStack whiteSpace='nowrap' id='eitum-status' color='gray.100' display='none'>
                <Spinner verticalAlign='middle' size='sm' display='inline-block' />
                <Box fontSize='sm' verticalAlign='middle' display='inline-block' ml={2} />
              </HStack>
              <Box id='eitum-linkbar' />
            </HStack>
          </HStack>
        </Container>
      </Box>

    </Flex>
  )
}